import React, { Component } from "react";
import { alertIcon, bulbIcon } from "../../../../common/utils/images";
import ModalPopUp from "../../../../common/components/pageBlocks/modalPopUp";
import commonContext, { AppContext } from "../../../../common/context/common";
import InputForm from "../../../../common/components/html/inputForm";
import PersonalAlternateAddress from "./personalAlternateAddress";
import { leadType } from "../../../../app";

interface IProps {}
interface IState {
    alternateAddressPopUpSwitch: boolean;
}
class PersonalDetailsCard extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    setLead: Function;
    base: String;
    constructor(props: IProps) {
        super(props);
        this.state = {
            alternateAddressPopUpSwitch: false,
        };
    }
    componentDidMount() {
        this.setLead = (this.context as AppContext).setLead;
        this.base = (this.context as AppContext).base;
    }
    handleOnChange = (e: any) => {
        const { setLead } = this.context;
        let state = {};
        state[e.target.name] = e.target.value;
        setLead(state);
    };
    render() {
        this.base = (this.context as AppContext).base;
        this.lead = (this.context as AppContext).lead as leadType;

        return (
            <>
                <div className="w-full reg-personal-details-wrap">
                    <h1 className="openSans-Reg text-black my-8 text-3xl md:text-3xl lg:text-3xl xl:text-4xl">
                        Registered personal details
                    </h1>
                    <div className="w-full flex flex-wrap">
                        <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                            {this.lead.pdApplicantFirstName ? (
                                <>
                                    <label
                                        htmlFor=""
                                        className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-gray-500"
                                    >
                                        Full Name
                                    </label>
                                    <p className="font-22px text-black">
                                        {this.lead.pdApplicantFirstName}{" "}
                                        {this.lead.pdApplicantMiddleName}{" "}
                                        {this.lead.pdApplicantLastName}
                                    </p>
                                </>
                            ) : (
                                ""
                            )}
                            {!this.lead.pdApplicantFirstName ? (
                                <InputForm
                                    label="Full Name"
                                    errorText="Please enter full Name"
                                    name="pdFirstName"
                                    handlerOnChange={(e) =>
                                        this.handleOnChange(e)
                                    }
                                />
                            ) : (
                                ""
                            )}
                        </div>

                        <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                            {this.lead.pdPanNo ? (
                                <>
                                    <label
                                        htmlFor=""
                                        className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-gray-500"
                                    >
                                        PAN Card
                                    </label>
                                    <p className="font-22px text-black">
                                        {this.lead.pdPanNo}
                                    </p>
                                </>
                            ) : (
                                <InputForm
                                    label="PAN Card"
                                    errorText="Please enter PAN Card"
                                    name="pdPanNo"
                                    handlerOnChange={(e) =>
                                        this.handleOnChange(e)
                                    }
                                />
                            )}
                        </div>
                        <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                            {this.lead.email && this.base != "dd-al" ? (
                                <>
                                    <label
                                        htmlFor=""
                                        className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-gray-500"
                                    >
                                        Email
                                    </label>
                                    <p className="font-22px text-black">
                                        {this.lead.email}
                                    </p>
                                </>
                            ) : (
                                <InputForm
                                    label="Email"
                                    errorText="Please enter PAN Card"
                                    name="email"
                                    handlerOnChange={(e) =>
                                        this.handleOnChange(e)
                                    }
                                    value={this.lead.email}
                                />
                            )}
                        </div>
                        <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                            <label
                                htmlFor=""
                                className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-gray-500"
                            >
                                Gender
                            </label>
                            <p className="font-22px text-black">
                                {this.lead.sex == "M" || this.lead.sex == "Male"
                                    ? "Male"
                                    : this.lead.sex == "F" ||
                                      this.lead.sex == "Female"
                                    ? "Female"
                                    : ""}
                            </p>
                        </div>
                        <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                            <label
                                htmlFor=""
                                className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-gray-500"
                            >
                                Marital Status
                            </label>
                            <p className="font-22px text-black">
                                {this.lead.maritalStatus}
                            </p>
                        </div>
                    </div>
                    <div className="w-full flex flex-wrap">
                        <div className="w-full lg:w-8/12 inline-block mb-3 lg:mb-8">
                            <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-gray-500">
                                Residential Address
                            </p>
                            <p className="font-22px text-black">
                                {this.lead.pdPresentAddress1}{" "}
                                {this.lead.pdPresentAddress2}{" "}
                                {this.lead.pdPresentAddress3}{" "}
                                {this.lead.pdPresentCity}{" "}
                                {this.lead.pdPresentPin}{" "}
                                {this.lead.pdPresentState}
                            </p>
                        </div>

                        {this.lead.pdPresentState != this.lead.state ||
                        this.lead.pdPermState ? (
                            <div className="w-full lg:w-8/12 inline-block mb-3 lg:mb-8 new-address-wrap">
                                <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-gray-500">
                                    {this.lead.pdPermState
                                        ? "Alternate Address"
                                        : ""}
                                </p>
                                <p className="font-22px text-black">
                                    {this.lead.pdPermAddress}{" "}
                                    {this.lead.pdPermAddress2}{" "}
                                    {this.lead.pdPermAddress3}{" "}
                                    {this.lead.pdPermCity}{" "}
                                    {this.lead.pdPermPinCode}{" "}
                                    {this.lead.pdPermState}
                                </p>
                                {this.lead.pdPermState ? (
                                    <a
                                        href="javascript:;"
                                        onClick={() =>
                                            this.setState({
                                                alternateAddressPopUpSwitch: true,
                                            })
                                        }
                                        className="blue-link-color no-underline hover:underline hover:text-black text-sm md:text-base lg:text-lg xl:text-lg transition-all mt-3 openSans-SemiBold"
                                        title="Edit"
                                    >
                                        Edit
                                    </a>
                                ) : (
                                    ""
                                )}
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                    {/* // * START alternate address block for ZD 10 seconds, QM 10 seconds */}
                    {this.base == "zd-10-seconds" ||
                    this.base == "qm-10-seconds" ? (
                        <>
                            {this.lead.pdPresentState == this.lead.state ? (
                                <div className="bg-light-yellow w-full lg:w-8/12 text-grey-darkest openSans-Reg py-2 px-4 text-sm rounded inline-flex items-start md:items-center">
                                    <img
                                        src={bulbIcon}
                                        className="mr-3"
                                        alt="Information icon"
                                        title="Information icon"
                                    />
                                    <span>
                                        Your vehicle will be registered to this
                                        address. However, if you would like to
                                        register your car to a new address in
                                        the same state. Click on the
                                        <strong> Add New Address </strong>
                                        button below.
                                    </span>
                                </div>
                            ) : (
                                ""
                            )}
                            {(this.lead.pdPresentState == this.lead.state ||
                                this.lead.pdPermState) &&
                            this.base != "qm-10-seconds" ? (
                                <div className="flex items-first md:items-center justify-center py-2 px-4 rounded-md text-track light-red w-full lg:w-8/12 text-sm">
                                    <span className="mr-3 icon-minw">
                                        <img
                                            className="object-cover"
                                            src={alertIcon}
                                            alt="Alert icon"
                                            title="Alert icon"
                                        />
                                    </span>
                                    Your vehicle can only be registered in the
                                    same state as your registered address.
                                    Please provide an address (Click on the Add
                                    New Address button below) to register your
                                    car in a different state.
                                </div>
                            ) : (
                                ""
                            )}
                            <div className="mb-8 mt-4">
                                <button
                                    title="Add Alternate Address"
                                    type="button"
                                    className="bg-transparent border-2 button-blue-border blue-link-color hover:text-white my-4 py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue button-white-blue transition-all modal-open"
                                    onClick={() =>
                                        this.setState({
                                            alternateAddressPopUpSwitch: true,
                                        })
                                    }
                                >
                                    Add Alternate Address
                                </button>
                            </div>
                        </>
                    ) : (
                        ""
                    )}
                    {/* // * END alternate address block for ZD 10 seconds */}
                    {/* // * START vehicle register info */}
                    {this.base == "dd-al" ? (
                        <>
                            <div className="bg-light-yellow w-full lg:w-8/12 text-grey-darkest openSans-Reg py-2 px-4 text-sm rounded inline-flex items-start md:items-center">
                                <img
                                    src={bulbIcon}
                                    className="mr-3"
                                    alt="Information icon"
                                    title="Information icon"
                                />
                                <span>
                                    Your vehicle will be registered to this
                                    address.
                                </span>
                            </div>
                        </>
                    ) : (
                        ""
                    )}
                    {/* // * END vehicle register info */}
                </div>
                {this.state.alternateAddressPopUpSwitch ? (
                    <ModalPopUp
                        onclickhandler={() =>
                            this.setState({
                                alternateAddressPopUpSwitch: false,
                            })
                        }
                    >
                        <PersonalAlternateAddress
                            onclickhandler={() =>
                                this.setState({
                                    alternateAddressPopUpSwitch: false,
                                })
                            }
                        />
                    </ModalPopUp>
                ) : (
                    ""
                )}
            </>
        );
    }
}

export default PersonalDetailsCard;
